import React, { useState, useEffect } from "react";
import { Divider } from "@mui/material";
import SingleHead from "./partials/SingleHead";
import PriceMatrix from "./partials/PriceMatrix";
import MethodSelection from "./partials/MethodSelection";
import InputLabel from "@mui/material/InputLabel";
import { useStyles, rowStyle } from "../../../Dashboard/customStyles";
import Chip from "@mui/material/Chip";
import { connect } from "react-redux";
import { PMT, CUMIPMT } from "@formulajs/formulajs";
import Grid from "@mui/material/Grid";
import Backdrop from "@mui/material/Backdrop";
import Swal from "sweetalert2";
import { MagnifyingGlass } from "react-loader-spinner";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import Box from "@mui/material/Box";

import {
  apiSolveGoalSeek,
  apiPriceMatrix,
} from "../../../../services/api.js/backend";
import { setAppIsLoading } from "../../../../store/modules/appState/actions";
import { setFinancialCalculatorData } from "../../../../store/modules/financingCalculator/actions";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import CurrencyFormatter from "currency-formatter";
import {generatePurchaserAcquisitionExpenses} from "../../../../store/modules/acquisitionExpenses/actions";
import {generateForecastedDOE} from "../../../../store/modules/valuation/actions";
import {generateForecastedRevenue} from "../../../../store/modules/valuation/actions";
import {generateForecastedGWC} from "../../../../store/modules/forecastGWC/actions";
import {generateForecastMaintenanceAndGrowthCapex} from "../../../../store/modules/forecastMGC/actions";
import {generateForecastCashToEarnings} from "../../../../store/modules/forecastCashToEarning/actions";
import {generateCapitalizationRate} from "../../../../store/modules/capitalizationRate/actions";
import {generateCapitalizationOfEarnings} from "../../../../store/modules/capitalizationOfEarnings/actions";
import {generateDiscountedCashFlowMethod} from "../../../../store/modules/discountedCFM/actions";
import BVAButton from "../../../../components/BVAButton/BVAButton";


const priceMatrixInterest = (element, parameters) => {
  let offerValue = element.value;
  let percentage = element.downpaymentPercentage;
  let downPayment = (percentage * offerValue) / 100;
  let amountFinanced = offerValue - downPayment;
  let totalInterest = 0;
  if (parameters.number_monthly_payments && amountFinanced && parameters.intrest_rate) {
    totalInterest =
      CUMIPMT(
        parameters.intrest_rate / 12 / 100,
        parameters.number_monthly_payments,
        Math.abs(amountFinanced),
        1,
        parameters.number_monthly_payments,
        0
      ) * -1;
  }
  return downPayment + amountFinanced + totalInterest
};

function FinancingCalculator({
  saveAllData,
  taxes,
  assetExpenses,
  stockExpenses,
  forecastedDOE,
  currentForecastRC,
  forecastMaintenanceAndGrowthCapex,
  currentForecastGWC,
  forecastCashToEarning,
  capitalizationRate,
  capitalizationOfEarnings,
  appState,
  setAppIsLoading,
  setFinancialCalculatorData,
  generateForecastedDOE,
  generateForecastedRevenue,
  generatePurchaserAcquisitionExpenses,
  generateForecastedGWC,
  generateForecastMaintenanceAndGrowthCapex,
  generateForecastCashToEarnings,
  generateCapitalizationRate,
  generateCapitalizationOfEarnings,
  financingCalculator,
  generateDiscountedCashFlowMethod
}) {
  const GOALSEEK_THRESHOLD = 0.1;
  const [resetCalculatorSettings, setResetCalculatorSettings] = useState(false)
  const [success, setSuccess] = useState(false);
  const [selection, setSelection] = useState(financingCalculator.method || "None");
  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      "&:hover": {
        bgcolor: green[700],
      },
    }),
  };
  const classes = useStyles();
  const [priceMatrixLoading, setPriceMatrixLoading] = useState(false);
  const [goalSeekValue, setGoalSeekValue] = useState(0);
  const [downPaymentPercentage, setDownPaymentPercentage] = useState(financingCalculator.downPaymentPercentage? financingCalculator.downPaymentPercentage : 100);
  const [
    acquisitionExpensesWorkingCapital,
    setAcquisitionExpensesWorkingCapital,
  ] = useState(financingCalculator.acquisitionExpensesWorkingCapital);
  const [interestRate, setInterestRate] = useState(financingCalculator.interestRate);
  const [monthlyPayments, setMonthlyPayments] = useState(financingCalculator.monthlyPayments);
  const [offerPriceValue, setOfferPriceValue] = useState( financingCalculator.offerPriceValue? financingCalculator.offerPriceValue :
    capitalizationOfEarnings?.afterTaxCapitalizedEarningsOfSubjectCompany
  );
  const [PriceMatrixData, setPriceMatrixData] = useState({
    status: false,
    results: [],
  });
  const [priceMatrixInterestData, setPriceMatrixInterestData] = useState({
    status: true,
    results: [],
  });
  const [showPriceMatrix, setShowPriceMatrix] = useState(false);
  const [offerPrice, setOfferPrice] = useState({
    title: "Offer Price & Deal Structure are Fair for Purchaser & Seller",
    rows: [
      {
        head: "Offering or Asking Price as a Stock Sale",
        value: offerPriceValue,
        fontWeight: "bold",
      },
    ],
  });

  useEffect(() => {
    //generateForecastedDOE()
    //generateForecastedRevenue()
    generatePurchaserAcquisitionExpenses({purchaseAcquisitionExpensesType: "asset"})
    generatePurchaserAcquisitionExpenses({purchaseAcquisitionExpensesType: "stock"})
    //generateForecastedGWC()
    //generateForecastMaintenanceAndGrowthCapex()
    //generateCapitalizationRate()
    //generateForecastCashToEarnings()
    //generateCapitalizationOfEarnings()    //all are generated in generateDiscountedCashFlowMethod()
    generateDiscountedCashFlowMethod()
    handleSelectionChange(financingCalculator.method || "None")
    setAppIsLoading(false)
  }, [])

  useEffect(() => {
    if (resetCalculatorSettings && capitalizationOfEarnings) {
      setOfferPriceValue(capitalizationOfEarnings?.afterTaxCapitalizedEarningsOfSubjectCompany)
    }
  }, [capitalizationOfEarnings, resetCalculatorSettings])


  let downPayment = Math.round(
    (downPaymentPercentage * offerPrice.rows[0].value) / 100
  );

  const cashNeeded = {
    title: "Cash Needed at Closing",
    rows: [
      {
        head: "Down Payment",
        value: downPayment,
      },
      {
        head: "Acquisition Expenses & Working Capital",
        value: acquisitionExpensesWorkingCapital,
      },
      {
        head: "Total Cash Invested",
        fontWeight: "bold",
        value: downPayment + Number(acquisitionExpensesWorkingCapital),
      },
    ],
  };
  const earningsGeneratedBusiness = {
    title: "Earnings Generated by Business",
    rows: [
      {
        head: "Seller's Discretionary Cash Flow",
        value: forecastedDOE?.forecastedValue,
      },
    ],
  };
  const reasonableCompensation = {
    title: "Reasonable Compensation",
    rows: [
      {
        head: "Reasonable Compensation",
        value: currentForecastRC?.forecastedReasonableCompensation,
        autoValue: currentForecastRC?.forecastedReasonableCompensation,
        manuality: true,
        manualType: "Auto"
      },
    ],
  };
  if(financingCalculator?.reasonableCompensation?.rows) {
    financingCalculator?.reasonableCompensation?.rows.map((obj, index) => {
      if(obj.manualType === "Manual") {
        reasonableCompensation.rows[index].value = obj.value;
        reasonableCompensation.rows[index].manualType = "Manual";
      }
    })
  }
  const reinvestmentAnalysis = {
    title: "Reinvestment Analysis",
    rows: [
      {
        head: "Estimated Growth in Working Capital",
        value: currentForecastGWC?.requiredAnnualInvestment,
        autoValue: currentForecastGWC?.requiredAnnualInvestment,
        manuality: true,
        manualType: "Auto"
      },
      {
        head: "Estimated Capital Expenditure",
        value: forecastMaintenanceAndGrowthCapex?.forecastedAnnualCapex,
        autoValue: forecastMaintenanceAndGrowthCapex?.forecastedAnnualCapex,
        manuality: true,
        manualType: "Auto"
      },
      {
        head: "Total Cash for Continued Operations",
        fontWeight: "bold",
        value:
          currentForecastGWC?.requiredAnnualInvestment + forecastMaintenanceAndGrowthCapex?.forecastedAnnualCapex,
      },
    ],
  };
  if(financingCalculator?.reinvestmentAnalysis?.rows) {
    financingCalculator?.reinvestmentAnalysis?.rows.map((obj, index) => {
      if(obj.manualType === "Manual") {
        reinvestmentAnalysis.rows[index].value = obj.value;
        reinvestmentAnalysis.rows[index].manualType = "Manual";
      }
    })
  }
  const investorReturn = {
    title: "Investor Return",
    rows: [
      {
        head: "Forecasted SDE Cash Flow",
        value: forecastedDOE?.forecastedDOE,
        autoValue: forecastedDOE?.forecastedDOE,
        manuality: true,
        manualType: "Auto"
      },
      {
        head: "Purchaser's Rate of Return",
        value: forecastCashToEarning?.cashToEarningsFactor?.preTaxNetCashFlowCapitalizationRate,
        type: "percent",
        autoValue: forecastCashToEarning?.cashToEarningsFactor?.preTaxNetCashFlowCapitalizationRate,
        manuality: true,
        manualType: "Auto"
      },
      {
        head: "Purchaser Required Return",
        fontWeight: "bold",
        value:
          (cashNeeded.rows[2].value * capitalizationRate?.preTaxCapitalizationRate?.preTaxNetCashFlowCapitalizationRate) / 100,
      },
    ],
  };
  if(financingCalculator?.investorReturn?.rows) {
    financingCalculator?.investorReturn?.rows.map((obj, index) => {
      if(obj.manualType === "Manual") {
        investorReturn.rows[index].value = obj.value;
        investorReturn.rows[index].manualType = "Manual";
      }
    })
  }
  const debtService = {
    title: " Debt Service",
    rows: [
      {
        head: "Cash to Service Financing",
        value:
          investorReturn.rows[0].value -
          reasonableCompensation.rows[0].value -
          investorReturn.rows[2].value -
          reinvestmentAnalysis.rows[2].value,
      },
    ],
  };
  let amountFinanced = offerPrice.rows[0].value - cashNeeded.rows[0].value;
  let monthlyPayment = 0;
  if (cashNeeded.rows[0].value != offerPrice.rows[0].value && monthlyPayments) {
    monthlyPayment = PMT(
      interestRate / 12 / 100,
      monthlyPayments,
      Math.abs(amountFinanced)
    );
  }

  const financingTerms = {
    title: "Financing Terms",
    rows: [
      {
        head: "Amount Financed",
        value: amountFinanced,
      },
      {
        head: "Interest Rate",
        value: interestRate,
        type: "percent",
      },
      {
        head: "Number of Monthly Payments",
        value: monthlyPayments,
        type: "None",
      },
      {
        head: "Monthly Payment on Promissory Note",
        value: Math.abs(monthlyPayment),
      },
      {
        head: "Annual Payment on Promissory Note",
        value: Math.abs(monthlyPayment * 12),
      },
    ],
  };
  let totalInterest = 0;
  if (monthlyPayments && amountFinanced && interestRate) {
    totalInterest =
      CUMIPMT(
        interestRate / 12 / 100,
        monthlyPayments,
        Math.abs(amountFinanced),
        1,
        monthlyPayments,
        0
      ) * -1;
  }

  const financingResults = {
    title: "Financing Results",
    rows: [
      {
        head: "Down Payment at Closing",
        value: downPayment,
      },
      {
        head: "Financing Principle Amount",
        value: amountFinanced,
      },
      {
        head: "Total Interest Over the Amortization Period",
        value: totalInterest,
      },
      {
        head: "Total Deal Consideration",
        fontWeight: "bold",
        value: downPayment + amountFinanced + totalInterest,
      },
    ],
  };

  let ebitda = investorReturn.rows[0].value - reasonableCompensation.rows[0].value;
  let freeCashFlow = investorReturn.rows[0].value - (reasonableCompensation.rows[0].value + reinvestmentAnalysis.rows[2].value);
  const cashFlowMetrics = {
    title: "Cash Flow Metrics",
    rows: [
      {
        head: "Seller's Discretionary Earnings",
        value: investorReturn.rows[0].value,
      },
      {
        head: "EBITDA",
        value: ebitda,
      },
      {
        head: "Free Cash Flow",
        value: freeCashFlow,
      },
    ],
  };

  let sellingPrice =
    offerPrice.rows[0].value / (ebitda + reasonableCompensation.rows[0].value);
  let sellingPriceEbitda =
    offerPrice.rows[0].value / ebitda;
  let sellingFreeCashFlow = offerPrice.rows[0].value / freeCashFlow;
  const sellingPriceMultiples = {
    title: "Selling Price Multiples",
    rows: [
      {
        head: "Selling Price to Seller's Discretionary Cash Flow",
        value: sellingPrice,
        type: "ratio",
      },
      {
        head: "Selling Price to EBITDA",
        value: sellingPriceEbitda,
        type: "ratio",
      },
      {
        head: "Selling Price to Free Cash Flow ",
        value: sellingFreeCashFlow,
        type: "ratio",
      },
    ],
  };
  let debtEbitda = 0;
  let debtEbitdaCapex = 0;
  if (Math.round(monthlyPayment) != 0) {
    debtEbitda = ebitda / Math.abs(monthlyPayment * 12);
    debtEbitdaCapex =
      (ebitda - reinvestmentAnalysis.rows[1].value) /
      Math.abs(monthlyPayment * 12);
  }

  const debtServiceCoverageRatios = {
    title: "Debt Service Coverage Ratios",
    rows: [
      {
        head: " (EBITDA) / (Interest + Principal)",
        value: debtEbitda,
        type: "ratio",
      },
      {
        head: " (EBITDA - Capex) / (Interest + Principal)",
        value: debtEbitdaCapex,
        type: "ratio",
      },
    ],
  };

  let cocOnEquity = downPayment ? freeCashFlow / downPayment * 100 : 0;
  // let cocWithRC = downPayment ? investorReturn.rows[0].value / downPayment : 0;    //if ebitda, not FCF
  let cocWithRC = downPayment ? (freeCashFlow + reasonableCompensation.rows[0].value) / downPayment * 100 : 0;
  const cashOnCashReturns = {
    title: "Cash on Cash Returns",
    rows: [
      {
        head: "Cash on Cash Return on Equity",
        value: cocOnEquity,
        type: "percent",
      },
      {
        head: "Cash on Cash Return with Reasonable Compensation",
        value: cocWithRC,
        type: "percent",
      },
    ],
  };

  useEffect(() => {
    let payload = {
      method: selection,
      offerPriceValue: offerPriceValue,
      downPaymentPercentage: downPaymentPercentage,
      acquisitionExpensesWorkingCapital: acquisitionExpensesWorkingCapital,
      interestRate: interestRate,
      monthlyPayments: monthlyPayments,
      offerPrice: offerPrice,
      cashNeeded: cashNeeded,
      earningsGeneratedBusiness: earningsGeneratedBusiness,
      reasonableCompensation: reasonableCompensation,
      reinvestmentAnalysis: reinvestmentAnalysis,
      investorReturn: investorReturn,
      debtService: debtService,
      financingTerms: financingTerms,
      financingResults: financingResults,
      cashFlowMetrics: cashFlowMetrics,
      sellingPriceMultiples: sellingPriceMultiples,
      debtServiceCoverageRatios: debtServiceCoverageRatios,
      cashOnCashReturns: cashOnCashReturns,
      totalInterest: totalInterest
    };
    setFinancialCalculatorData(payload);
  }, [
    selection,
    offerPriceValue,
    downPaymentPercentage,
    acquisitionExpensesWorkingCapital,
    interestRate,
    monthlyPayments,
    totalInterest
  ]);

  useEffect(() => {
    if (goalSeekValue > GOALSEEK_THRESHOLD) {
      setOfferPrice((preValue) => {
        let newValue = {
          ...preValue,
          title: "Offer Price & Deal Structure Favor the Purchaser",
        };
        return newValue;
      });
    } else if (goalSeekValue < -GOALSEEK_THRESHOLD) {
      setOfferPrice((preValue) => {
        let newValue = {
          ...preValue,
          title: "Offer Price & Deal Structure Favor the Seller",
        };
        return newValue;
      });
    } else {
      setOfferPrice((preValue) => {
        let newValue = {
          ...preValue,
          title: "Offer Price & Deal Structure are Fair for Purchaser & Seller",
        };
        return newValue;
      });
    }
  }, [goalSeekValue]);

  useEffect(() => {
    let tempPrice = {...offerPrice}
    tempPrice.rows[0].value = offerPriceValue;
    setOfferPrice({ ...tempPrice });
  }, [offerPriceValue]);

  const calculatePricing = (parameters) => {
    let offeringAskingPrice = offerPriceValue;
    let downpaymentPercentage = parameters["downpayment_percentage"];
    let downpayment = (offeringAskingPrice * downpaymentPercentage) / 100;
    let acquisitionExpensesWorkingCapital = parameters["acquisition_expenses_working_capital"];

    // Calculations
    let totalCashInvested = downpayment + acquisitionExpensesWorkingCapital;
    let totalCashContinuedOperations =
      parameters["estimated_growth_working_capital"] +
      parameters["estimated_capital_expenditure"];

    let purchaserRequiredReturn = (totalCashInvested * parameters["purchaser_rate_return"]) / 100;
    let cashServiceFinancing = (
      parameters["forecasted_sde_cash_flow"]
      - parameters["reasonable_compensation"]
      - purchaserRequiredReturn
      - totalCashContinuedOperations
    )

    let amountFinanced = offeringAskingPrice - downpayment;

    let rate = parameters["intrest_rate"] / 100 / 12;
    let nper = parameters["number_monthly_payments"];
    let pv = amountFinanced;

    let monthlyPaymentPromissoryNote = 0;
    if (downpayment != offeringAskingPrice) {
      monthlyPaymentPromissoryNote = Math.abs(PMT(rate, nper, pv));
    }
    let annualPaymentPromissoryNote = monthlyPaymentPromissoryNote * 12;
    let threshold = 0.01;

    let checkValue = cashServiceFinancing - annualPaymentPromissoryNote;
    let goalSeekValue = 0;
    if (downpayment != offeringAskingPrice) {
      if (Math.abs(checkValue) < threshold) {
        goalSeekValue = 0;
      } else {
        goalSeekValue = checkValue;
      }
    } else {
      if (Math.abs(cashServiceFinancing) < threshold) {
        goalSeekValue = 0;
      } else {
        goalSeekValue = checkValue;
      }
    }
    return goalSeekValue;
  };


  useEffect(() => {
    let parameters = {
      downpayment_percentage: downPaymentPercentage,
      acquisition_expenses_working_capital: acquisitionExpensesWorkingCapital,
      seller_discretionary_cash_flow: earningsGeneratedBusiness.rows[0].value,
      reasonable_compensation: reasonableCompensation.rows[0].value,
      estimated_growth_working_capital: reinvestmentAnalysis.rows[0].value,
      estimated_capital_expenditure: reinvestmentAnalysis.rows[1].value,
      forecasted_sde_cash_flow: investorReturn.rows[0].value,
      purchaser_rate_return: investorReturn.rows[1].value,
      intrest_rate: interestRate,
      number_monthly_payments: monthlyPayments,
    };
    let result = calculatePricing(parameters);
    setGoalSeekValue(result);
  }, [
    selection,
    offerPriceValue,
    downPaymentPercentage,
    acquisitionExpensesWorkingCapital,
    interestRate,
    monthlyPayments,
    forecastedDOE,
    currentForecastRC,
    currentForecastGWC,
    forecastMaintenanceAndGrowthCapex,
    forecastCashToEarning,
    capitalizationRate,
    capitalizationOfEarnings,
    taxes,
    reasonableCompensation,
    reinvestmentAnalysis,
    investorReturn
  ]);
  const startGoalSeek = async () => {
    setAppIsLoading(true);
    try {
      let payload = {
        starting_value: offerPrice.rows[0].value,
        parameters: {
          downpayment_percentage: downPaymentPercentage,
          acquisition_expenses_working_capital: acquisitionExpensesWorkingCapital,
          seller_discretionary_cash_flow: earningsGeneratedBusiness.rows[0].value,
          reasonable_compensation: reasonableCompensation.rows[0].value,
          estimated_growth_working_capital: reinvestmentAnalysis.rows[0].value,
          estimated_capital_expenditure: reinvestmentAnalysis.rows[1].value,
          forecasted_sde_cash_flow: investorReturn.rows[0].value,
          purchaser_rate_return: investorReturn.rows[1].value,
          intrest_rate: interestRate,
          number_monthly_payments: monthlyPayments,
        },
      };
      const data = await apiSolveGoalSeek(payload);
      setAppIsLoading(false);
      if (data.status) {
        Swal.fire("Completed!", data.message, "success");
        setOfferPriceValue(Math.round(data.value));

      } else {
        Swal.fire({
          icon: "error",
          title: "Failure",
          text: data.message,
        });
      }
    } catch (ex) {
      setAppIsLoading(false);
      Swal.fire({
        icon: "error",
        title: "Failure",
        text: ex,
      });
    }
  };

  const startPriceMatrix = async () => {
    setPriceMatrixLoading(true);
    try {
      let payload = {
        start_percentage: 0,
        end_percentage: 100,
        starting_value: offerPrice.rows[0].value,
        parameters: {
          downpayment_percentage: downPaymentPercentage,
          acquisition_expenses_working_capital:
            acquisitionExpensesWorkingCapital,
          seller_discretionary_cash_flow:
            earningsGeneratedBusiness.rows[0].value,
          reasonable_compensation: reasonableCompensation.rows[0].value,
          estimated_growth_working_capital: reinvestmentAnalysis.rows[0].value,
          estimated_capital_expenditure: reinvestmentAnalysis.rows[1].value,
          forecasted_sde_cash_flow: investorReturn.rows[0].value,
          purchaser_rate_return: investorReturn.rows[1].value,
          intrest_rate: interestRate,
          number_monthly_payments: monthlyPayments,
        },
      };
      let apiRequests = [];
      for (let index = 0; index < 10; index++) {
        let start = index * 10;
        let end = start + 9;
        if (index !== 0) {
          start = start + 1;
          end = start + 9;
        } else {
          end = start + 10;
        }

        payload.start_percentage = start;
        payload.end_percentage = end;
        apiRequests.push(apiPriceMatrix(payload));
      }
      const apiData = await Promise.all(apiRequests);
      let data = {
        status: true,
        results: [],
      };
      apiData.forEach((element) => {
        if (!element.status) {
          data.status = false;
        } else {
          data.results = [...data.results, ...element.results];
        }
      });
      
      let interestData = {...priceMatrixInterestData}
      interestData.results = []
      data.results.forEach((element) => {
      let temp = priceMatrixInterest(element, apiData[0].parameters);
      interestData.results.push({value: temp, downpaymentPercentage: element.downpaymentPercentage});
      });
      setFinancialCalculatorData({
        ...financingCalculator,
        priceMatrix: {
          price: data.results.map((obj) => ({ downpaymentPercentage: obj.downpaymentPercentage, value: obj.value })),
          deal: interestData.results
        }
      })
      setPriceMatrixLoading(false);
      if (data.status) {
        Swal.fire("Completed!", data.message, "success");
        setPriceMatrixData(data);
        setPriceMatrixInterestData(interestData);
        // setOfferPriceValue(Math.round(data.value));
      } else {
        Swal.fire({
          icon: "error",
          title: "Failure",
          text: data.messaae,
        });
      }
    } catch (ex) {
      setPriceMatrixLoading(false);
      Swal.fire({
        icon: "error",
        title: "Failure",
        text: ex,
      });
    }
  };

  const handleSelectionChange = (method) => {
    setSelection(method);
    let value = acquisitionExpensesWorkingCapital;
    if(method === "None") value = 0;
    else if(method === "Stock") value = stockExpenses;
    else if(method === "Asset") value = assetExpenses;
    setAcquisitionExpensesWorkingCapital(value);
  };

  const handleManualChange = (value, type, rowIndex, group) => {
    let groupName = group.charAt(0).toLowerCase() + group.slice(1).replace(/ /g, "");
    let newGroupData = financingCalculator[groupName];
    newGroupData.rows[rowIndex][type] = value;
    
    if(type === "manualType" && value === "Auto") newGroupData.rows[rowIndex].value = newGroupData.rows[rowIndex].autoValue;
    if(groupName === "reinvestmentAnalysis") newGroupData.rows[2].value = newGroupData.rows[0].value + newGroupData.rows[1].value;
    if(groupName === "investorReturn") newGroupData.rows[2].value = newGroupData.rows[1].value * cashNeeded.rows[2].value / 100;

    setFinancialCalculatorData({
      ...financingCalculator,
      [group]: newGroupData
    })
  };

  return (
    <>
    <div className="flex items-center justify-between pr-10">
      <h2 className="sectionHead">Financing Calculator</h2>
      <MethodSelection value={selection} handleChange={(e) => handleSelectionChange(e.target.value)} />
    </div>
    <div className="dashboard-content">
      <div className="data-title-container">
        <div></div>

        <div className="data-title">
          <h6>{appState.companyData.name}</h6>
          <p>Financing Calculator</p>
        </div>
      </div>
    </div>
    <section className="py-0">
      {
        <div
          style={{ display: "flex", justifyContent: "center", margin: "10px" }}
        >
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={appState.isLoading}
          >
            <MagnifyingGlass
              visible={true}
              height="80"
              width="80"
              glassColor="#c0efff"
              color="#e15b64"
            />
          </Backdrop>
        </div>
      }
      <div>
        <Divider style={{ paddingBottom: "0.5rem" }}>
          <Chip label="CALCULATOR SETTINGS" />
        </Divider>
        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Offering or Asking Price as a Stock Sale
            </InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              className={classes.input}
              size="small"
              value={offerPriceValue}
              startAdornment
              startAdornmentLabel={"$"}
              onChange={(val) =>
                setOfferPriceValue(
                  Number(CurrencyFormatter.unformat(val, { code: "USD" }))
                )
              }
            ></BVAInput>
          </div>
        </div>
        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Down Payment Percentage
            </InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              className={classes.input}
              size="small"
              value={downPaymentPercentage}
              startAdornment
              startAdornmentLabel={"%"}
              onChange={(val) =>
                setDownPaymentPercentage(
                  Number(CurrencyFormatter.unformat(val, { code: "USD" }))
                )
              }
            ></BVAInput>
          </div>
        </div>
        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Acquisition Expenses & Working Capital
            </InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled={selection === "Manual" ? false : true}
                className={classes.input}
                size="small"
                value={acquisitionExpensesWorkingCapital}
                startAdornment
                startAdornmentLabel={"$"}
                onChange={(val) =>
                  setAcquisitionExpensesWorkingCapital(
                    Number(CurrencyFormatter.unformat(val, { code: "USD" }))
                  )
                }
              />
            </div>
          </div>
        </div>
        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Interest Rate
            </InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              className={classes.input}
              size="small"
              value={interestRate}
              startAdornment
              startAdornmentLabel={"%"}
              onChange={(val) =>
                setInterestRate(
                  Number(CurrencyFormatter.unformat(val, { code: "USD" }))
                )
              }
            ></BVAInput>
          </div>
        </div>
        <div style={rowStyle.baseRow}>
          <div style={rowStyle.labelRow}>
            <InputLabel style={{ fontWeight: "bold" }}>
              Number of Monthly Payments
            </InputLabel>
          </div>
          <div style={rowStyle.fieldRow}>
            <BVAInput
              className={classes.input}
              size="small"
              value={monthlyPayments}
              onChange={(val) =>
                setMonthlyPayments(
                  Number(CurrencyFormatter.unformat(val, { code: "USD" }))
                )
              }
            ></BVAInput>
          </div>
        </div>
      </div>
      <Divider style={{ paddingBottom: "0.5rem", paddingTop: "0.5rem" }}>
        <Chip label="CALCULATOR" />
      </Divider>
      <div style={rowStyle.baseRow}>
        <div style={rowStyle.labelRow}>
          <InputLabel style={{ fontWeight: "bold" }}>
            Goal Seek
          </InputLabel>
        </div>
        <div style={rowStyle.fieldRow}>
          {/* <BVAInput
          disabled
          size="small"
          id="numberMonthlyPayments"
          value={goalSeekValue}/> */}
          <div className="flex items-center">
            <div>
              <BVAButton
              kind="primary"
              height="40px"
              onClick={startGoalSeek}>
                Solve
              </BVAButton>
            </div>
            <div className="ml-2">
              <BVAButton
              kind="primary-outlined"
              height="40px"
              onClick={() => {
                setOfferPriceValue(capitalizationOfEarnings?.afterTaxCapitalizedEarningsOfSubjectCompany);
                setResetCalculatorSettings(true)
              }}>
                Clear
              </BVAButton>
            </div>
          </div>
          <Box sx={{ position: "relative" }}>

          </Box>
        </div>
      </div>
      <div
        style={{
          marginTop: "2rem",
          marginBottom: "0.5rem",
          justifyContent: "center",
          flexDirection: "row",
          display: "flex",
        }}
      >
        <div>
          <BVAButton
            kind="primary"
            height="40px"
            disabled={priceMatrixLoading}
            onClick={startPriceMatrix}
          >
            Calculate Price Matrix
          </BVAButton>
          {priceMatrixLoading && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px",
              }}
            />
          )}
        </div>
        <div className="ml-2">
          <BVAButton
            kind="primary-outlined"
            height="40px"
            disabled={priceMatrixLoading}
            onClick={() => setShowPriceMatrix(!showPriceMatrix)}
          >
            {showPriceMatrix ? "Hide Price Matrix" : "Show Price Matrix"}
          </BVAButton>
        </div>
      </div>

      {showPriceMatrix && (
        <div>
          <Grid
            container
            columnSpacing={0.5}
            justifyContent="center"
            direction="row"
          >
            <Grid item xs={6} sm={4}>
              <PriceMatrix rows={PriceMatrixData.results}></PriceMatrix>
            </Grid>
            <Grid item xs={6} sm={4}>
              <PriceMatrix rows={priceMatrixInterestData.results}></PriceMatrix>
            </Grid>
          </Grid>
        </div>
      )}

      <div>
        {Math.abs(goalSeekValue) <= GOALSEEK_THRESHOLD ? (
          <SingleHead data={offerPrice}></SingleHead>
        ) : (
          <SingleHead
            data={offerPrice}
            titleColor={goalSeekValue > 0 ? "#f48fb1" : "#43a047"}
          ></SingleHead>
        )}
      </div>

      <div>
        <SingleHead data={cashNeeded}></SingleHead>
      </div>

      {/* <div>
        <SingleHead data={earningsGeneratedBusiness}></SingleHead>
      </div> */}

      <div>
        <SingleHead data={reasonableCompensation} onChange={handleManualChange}></SingleHead>
      </div>

      <div>
        <SingleHead data={reinvestmentAnalysis} onChange={handleManualChange}></SingleHead>
      </div>

      <div>
        <SingleHead data={investorReturn} onChange={handleManualChange}></SingleHead>
      </div>

      <div>
        <SingleHead data={debtService}></SingleHead>
      </div>

      <div>
        <SingleHead data={financingTerms}></SingleHead>
      </div>

      <div>
        <SingleHead data={financingResults}></SingleHead>
      </div>

      <div>
        <SingleHead data={cashFlowMetrics}></SingleHead>
      </div>

      <div>
        <SingleHead data={sellingPriceMultiples}></SingleHead>
      </div>

      <div>
        <SingleHead data={debtServiceCoverageRatios}></SingleHead>
      </div>

      <div>
        <SingleHead data={cashOnCashReturns}></SingleHead>
      </div>
    </section>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    financingCalculator: state.financingCalculator,
    assetExpenses: state.acquisitionExpenses?.assetPurchaserAcquisitionExpenses?.additionalCapitalNeededAtClosing,
    stockExpenses: state.acquisitionExpenses?.stockPurchaserAcquisitionExpenses?.additionalCapitalNeededAtClosing,
    forecastedDOE: state.valuation.forecastedDOE,
    currentForecastRC: state.forecastRC.currentForecastRC,
    currentForecastGWC: state.forecastGWC.currentForecastGWC,
    forecastMaintenanceAndGrowthCapex: state.forecastMGC.forecastMaintenanceAndGrowthCapex,
    forecastCashToEarning: state.forecastCashToEarning.forecastCashToEarnings,
    capitalizationRate: state.capitalizationRate.capitalizationRate,
    capitalizationOfEarnings: state.capitalizationOfEarnings.capitalizationOfEarnings,
    taxes: state.taxes,
    appState: state.appState,
  };
};

export default connect(mapStateToProps, {
  setAppIsLoading,
  setFinancialCalculatorData,
  generateForecastedDOE,
  generateForecastedRevenue,
  generatePurchaserAcquisitionExpenses,
  generateForecastedGWC,
  generateForecastMaintenanceAndGrowthCapex,
  generateForecastCashToEarnings,
  generateCapitalizationRate,
  generateCapitalizationOfEarnings,
  generateDiscountedCashFlowMethod
})(FinancingCalculator);
